import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    text: "We also had a great conversation, and the atmosphere was excellent. Best cut I've had in years.",
    name: "Google Review",
  },
  {
    text: "If you're looking for a barber to make your personal barber, this is the place. Hands down.",
    name: "Google Review",
  },
  {
    text: "Awesome experience and a great haircut! Clean shop, friendly, and seriously skilled.",
    name: "Google Review",
  },
];

const bars = [
  { star: 5, pct: 95 },
  { star: 4, pct: 5 },
  { star: 3, pct: 0 },
  { star: 2, pct: 0 },
  { star: 1, pct: 0 },
];

export const Reviews = () => {
  return (
    <section id="reviews" className="py-24 sm:py-32 bg-barber-surface border-y border-barber-gold/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <p className="uppercase tracking-[0.35em] text-barber-gold text-xs mb-4">Word On The Street</p>
        <h2 className="font-heading text-4xl sm:text-5xl font-bold text-barber-cream tracking-tight mb-16">
          What Clients Say
        </h2>

        <div className="grid lg:grid-cols-3 gap-8 items-stretch">
          {/* loud gold rating panel */}
          <div data-testid="rating-panel" className="bg-barber-gold text-white p-8 flex flex-col justify-between relative overflow-hidden">
            <div className="relative">
              <span className="uppercase tracking-[0.3em] text-xs font-semibold text-white/80">
                Google Rating
              </span>
              <div className="flex items-end gap-4 mt-3">
                <span className="font-heading text-7xl font-bold leading-none text-white">4.9</span>
                <div className="pb-2">
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-white text-white" />
                    ))}
                  </div>
                  <span className="text-sm font-medium">out of 5.0</span>
                </div>
              </div>
            </div>
            <div className="relative mt-8 space-y-2">
              {bars.map((b) => (
                <div key={b.star} className="flex items-center gap-3">
                  <span className="text-xs font-semibold w-3">{b.star}</span>
                  <Star className="w-3 h-3 fill-white text-white" />
                  <div className="flex-1 h-2 bg-white/25">
                    <div className="h-full bg-white transition-all" style={{ width: `${b.pct}%` }} />
                  </div>
                </div>
              ))}
            </div>
            <p className="relative mt-8 text-sm font-semibold border-t border-white/25 pt-4">
              Rated by 37 happy clients in Worcester, MA
            </p>
          </div>

          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-6">
            {reviews.map((r, i) => (
              <motion.div
                key={i}
                data-testid={`review-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className={`bg-barber-bg border border-barber-gold/20 p-8 hover:border-barber-gold/50 transition-colors ${
                  i === 2 ? "sm:col-span-2" : ""
                }`}
              >
                <Quote className="w-7 h-7 text-barber-gold/60 mb-4" />
                <p className="text-barber-cream leading-relaxed">"{r.text}"</p>
                <div className="mt-4 flex items-center gap-2">
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, j) => (
                      <Star key={j} className="w-3.5 h-3.5 fill-barber-gold text-barber-gold" />
                    ))}
                  </div>
                  <span className="text-barber-muted text-xs uppercase tracking-widest">{r.name}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
